export var updateOrgUnitActive = function (_input) { return ({
    success: true
}); };
